// Brand assets served from the shared Lanetix S3 bucket.
const ASSETS_BASE_URL = 'https://s3.us-east-1.amazonaws.com/assets.lanetix.com'

export const LOGO_WHITE = `${ASSETS_BASE_URL}/winmore-logo-white.png`
export const FAVICON_LIGHT = `${ASSETS_BASE_URL}/favicon-light.png`
export const FAVICON_DARK = `${ASSETS_BASE_URL}/favicon-dark.png`
